import React, { useContext, useState, useEffect } from 'react';
import { Fade } from "react-awesome-reveal";
import { Container, Row, Col } from 'react-bootstrap';
import BlogTitle from '../BlogTitle/BlogTitle';
import AboutImg from '../Image/AboutImg';
import PortfolioContext from '../../context/context';

const AboutMe = () => {
  const { about } = useContext(PortfolioContext);
  const { img, paragraphOne, paragraphTwo, paragraphThree, resume } = about;
  const [direction, setDirection] = useState('');

  useEffect(() => {
    if (window.innerWidth > 769) {
      setDirection('right');
    } else {
      setDirection('up');
    }
  }, []);

  return (
    <section id="about">
      <Container>
        <BlogTitle title="About Me" />
        <Row className="about-wrapper">
          <Col md={6} sm={12}>
            <Fade triggerOnce duration={1000} delay={600}>
              <div className="about-wrapper__image">
                <AboutImg alt="profile picture" filename={img} />
              </div>
            </Fade>
          </Col>
          <Col md={6} sm={12}>
            <Fade triggerOnce direction={direction} duration={1000} delay={1000}>
              <div className="about-wrapper__info">
                <p className="about-wrapper__info-text">{paragraphOne}</p>
                <p className="about-wrapper__info-text">{paragraphTwo}</p>
                <p className="about-wrapper__info-text">{paragraphThree}</p>
                {resume && (
                  <span className="d-flex mt-3">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta-btn cta-btn--resume"
                      href={resume}
                    >
                      Resume
                    </a>
                  </span>
                )}
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutMe;
